import { render, staticRenderFns } from "./imgModal.vue?vue&type=template&id=0a2f9d39"
import script from "./imgModal.vue?vue&type=script&lang=js"
export * from "./imgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports